import { TranslationObject } from '@ngx-translate/core';

const ru: TranslationObject = {
  ru: 'Русский',
  en: 'Английский',
  app: {
    title: 'Предпусковая проверка по ТБ',
    forms: {
      ok: 'Ok',
      cancel: 'Отменить',
      continue: 'Продолжить',
      selectAll: 'Выбрать все',
      save: 'Сохранить',
      labels: {
        businessUnit: 'Бизнес подразделение',
        organization: 'Организация/подразделение',
        user: 'Пользователь',
        name: 'Имя',
        description: 'Описание',
        displayRichEditor: 'Показать расширенный редактор',
        statusOptions: {
          draft: 'Draft',
          initiated: 'Initiated',
          inProgress: 'In Progress',
          completed: 'Completed',
          pendingApproval: 'Pending Approval',
          approved: 'Approved',
          closed: 'Closed',
        },
        placeHolderDescription: 'Введите описание',
        placeHolderReviewType: 'Выберите тип проверки',
        mandatory: 'Обязательный',
        isActive: 'Активный',
      },
      categories: {
        placeholders: {
          categoryName: 'Название категории',
        },
      },
      create: 'Создать',
      unsavedChangesWarning:
        'Обнаружены несохраненные изменения. Если вы покинете эту страницу, внесенные вами изменения будут потеряны.<br>Вы хотите продолжить?',
      validation: {
        required: '{{controlName}} обязательно',
        invalidEmail: 'Пожалуйста, введите корректный адрес электронной почты',
      },
    },
    warnings: {
      removeOwnAdminRights:
        'Вы удалили свои права администратора. Пожалуйста, обновите веб-страницу, чтобы избежать неисправностей.',

      removeOwnAccess: 'Вы удалили свой доступ. Пожалуйста, обновите веб-страницу, чтобы избежать неисправностей.',
    },
  },
  header: {
    support: 'Поддержка',
    userGuide: 'Руководство пользователя',
  },
  navigation: {
    pssrs: 'ППТБ',
    projects: 'Проекты',
    actionsItems: 'Пункты действий',
    administration: 'Управление',
    hierarchyManagement: 'Управление иерархией',
    businessUnits: 'Бизнес-подразделения',
    organizations: 'Подразделения',
    facilityHierarchy: 'Иерархия объекта',
    accessManagement: 'Управление доступом',
    organizationUsers: 'Пользователи',
    buAdmins: 'Администраторы пользователей',
    userGroups: 'Группы пользователей по действиям',
    systemAdmins: 'Системные администраторы',
    pssrConfiguration: 'Конфигурация ППТБ',
    templates: 'Контрольные списки ППТБ',
    categories: 'Категории бизнес-единицы',
  },
  functionalReviewList: {
    title: 'Функциональный обзор',
    noFunctionalReview: 'Нет функционального обзора',
    id: 'ID',
    code: 'Код',
    question: 'Вопрос',
    answer: 'Ответ',
    comment: 'Комментарий',
    updatedBy: 'Обновлено',
    updatedDate: 'Дата обновления',
    createNewFunctionalReview: 'создать новый функциональный обзор',
    reviewType: 'Тип обзора',
    addQuestion: 'Добавить Вопрос',
    description: 'Описание',
    subSection: 'Подраздел',
    clearAnswer: 'Очистить Ответ',
    deleteQuestion: 'Удалить Вопрос',
    deleteQuestionTitle: 'Удалить Вопрос',
    confirmDeleteQuestion:
      '<span>Вы уверены, что хотите удалить этот вопрос?</span><br><br><span><b>Вопрос:</b> {{ description }}</span>',
    generateReport: 'Создать Отчет',
    completeReview: 'Завершить Обзор',
    generateSuccessMessage: 'Отчет успешно создан',
    reviewSuccessMessage: 'Функциональный обзор успешно завершен',
  },
  admin: {
    sysAdminList: {
      title: 'Системные Администраторы',
      addSysAdmin: 'добавить системного администратора',
      fullName: 'полное имя',
      email: 'электронная почта',
      disabled: 'Отключен',
      dialogs: {
        removeAccessHeader: 'Подтверждение',
        removeAccessMessage:
          'Вы уверены, что хотите удалить доступ системного администратора для: [{{firstName}} {{lastName}}]?',
      },
    },
    businessUnitLists: {
      title: 'Бизнес-подразделения',
      addBusinessUnit: 'добавить бизнес-единицу',
      tableTitle: 'Бизнес подразделение',
    },
    businessUnitCreate: {
      title: 'Создать бизнес-единицу',
    },
    businessUnitEdit: {
      title: 'Редактировать бизнес-единицу',
    },
    businessUnitForm: {
      sections: {
        supportInformation: {
          titleSupport: 'Информация о поддержке',
          name: 'Имя',
          businessUnitSupportInfo: 'Информация о поддержке бизнес-единицы',
          businessUnitSupportInfoDescription: 'Эта информация будет отображаться на странице поддержки',
          displayRichEditor: 'показать расширенный редактор',
        },
        approvalForAccess: {
          titleApproval: 'Одобрение доступа',
          userNeedsBuAdmin: 'Пользователю необходимо, чтобы администратор бизнес-единицы предоставил доступ',
          userGetsInstantAccess: 'Пользователь получит мгновенный доступ',
        },
        labels: {
          titleLabels: 'Метки',
          hierarchyLabel1: 'Метка иерархии 1',
          hierarchyLabel2: 'Метка иерархии 2',
          hierarchyLabel3: 'Метка иерархии 3',
          pssrLabel: 'Метка PSSR',
          organizationLabel: 'Метка организации',
          eventNameLabel: 'Метка названия события',
          p3: 'P3',
          p4: 'P4',
          p5: 'P5',
          placeholderDefault: 'значение по умолчанию - \'проект\'',
          show: 'Показать',
        },
        pssrConfigurations: {
          titleConfigurations: 'Конфигурации PSSR',
          stagnantPssrInterval: 'Интервал застоя PSSR',
          instructions: 'Инструкции',
          instructionsDescription: 'Общие инструкции по застою для PSSR',
          showProject: 'Хотите отображать Проект?',
          projectDisplayType: 'Как вы хотите отображать Проект?',
          dropdown: 'выпадающий список',
          input: 'ввод',
          showKms: 'Хотите отображать KMS? При создании нового PSSR будет отображаться кнопка "получить из KMS".',
          showQaqcModule: 'Хотите отображать модуль QAQC в Проекте? Требует включения проекта.',
          showWetSignatureApproval:
            'Хотите разрешить мокрую подпись PSSR? Это позволяет представителю по операциям утверждать PSSR в статусе ожидания утверждения. Кнопка гласит "утвердить с мокрой подписью".',
          pssrTypesToShow: 'Какие типы PSSR вы хотите отображать?',
          ccc: 'CCC',
          factory: 'Завод',
          moc: 'MOC',
          nonMoc: 'НЕ-MOC',
          orr: 'ORR',
          pfsr: 'PFSR',
          test: 'Тест',
          showNaResponse:
            'Хотите разрешить пользователям отвечать Н/Д? Если выбрать нет, потребуется комментарий или пункт действия, чтобы считаться завершенным.',
          sendScheduledEmail:
            'Хотите отправлять запланированное письмо каждый понедельник в 8:00 CST пользователям с ожидающими пунктами действий?',
          showConstructionComplete:
            'Хотите отображать Сертификат о завершении строительства (CCC) для некоторых заголовков/названий/меток?',
          showOperationReadiness:
            'Хотите отображать Проверку готовности к эксплуатации (ORR) для некоторых заголовков/названий/меток?',
          showVerbalApproval:
            'Хотите отображать устное одобрение? Это показывает ввод в мобильном приложении для ручной записи того, кто одобряет. Это не вызывает никаких действий и может быть выполнено руководителем или утверждающим.',
          allowLeadToDelete:
            'Хотите разрешить руководителю удалять вопросы для PSSR в статусе черновика или запущенного?',
          allowTeamMemberActions:
            'Хотите разрешить любому члену команды отвечать на вопросы, подписывать вопросы и создавать пункты действий до утверждения?',
          restrictMocWo:
            'Хотите ограничить номер проекта MOCWO? Если выбрать "да", для создания PSSR требуются MOC и WO.',
          allowLeadsToShare:
            'Хотите разрешить руководителям делиться устройством с утверждающими? Если выбрать "да", руководитель может поделиться устройством с утверждающим, если утверждающий присутствует для подписи.',
          requireFinalApprovalBeforeInitiation:
            'Хотите требовать окончательного утверждения перед инициацией? Если "да", PSSR должен иметь окончательного утверждающего для запуска.',
          allowFinalApproverNotifications: 'Хотите разрешить окончательному утверждающему получать все уведомления?',
          allowFinalApproverSubmit: 'Хотите разрешить окончательному утверждающему отправлять на утверждение?',
          allowMultiplesApprovers: 'Хотите разрешить нескольких утверждающих?',
          ShowSectionsCollapsed: 'Хотите сворачивать разделы PSSR при редактировании?',
          requireActionItemDueDate: 'Хотите требовать срок выполнения для пунктов действий?',
          limitAccessToAIOwner:
            'Хотите ограничить владельца или назначенного пункта действия от изменения описания, изменения срока выполнения или удаления пункта действия?',
        },
        actionItemConfigurations: {
          titleItemConfigurations: 'Конфигурации пунктов действий',
          sendToMoc: 'Хотите отправлять пункты действий в MOC?',
          p3: 'P3',
          p4: 'P4',
          allowTeamLeadAttach:
            'Хотите разрешить руководителю команды прикреплять и изменять пункт действия? Если выбрать "да", руководители могут прикреплять только файлы, назначенных, статус и комментарий после ожидающего утверждения.',
          allowActionItemOwnerAttach:
            'Хотите разрешить владельцу пункта действия прикреплять в любом статусе, пока PSSR не закрыт?',
        },
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Не зарегистрирован',
      forms: {
        submit: 'Запрос доступа',
      },
      dialogTitle: 'Запрос доступа',
      dialogSubtitle: 'Вы собираетесь запросить доступ к <strong>{{Name}}</strong>, Вы хотите продолжить?',
      reloadWarning:
        'Если вы открыли эту страницу, но уже имеете доступ, пожалуйста, нажмите на следующую ссылку, чтобы перезагрузить. В противном случае свяжитесь со службой поддержки.',
      reload: 'Перезагрузить',
    },
    pendingAccess: {
      title: 'Здравствуйте, ваш запрос на доступ находится в обработке',
      reloadWarning:
        'Если вы открыли эту страницу, но уже имеете доступ, пожалуйста, нажмите на следующую ссылку, чтобы перезагрузить. В противном случае свяжитесь со службой поддержки.',
      reload: 'Перезагрузить',
    },
  },
  footer: {
    text: 'Chevron Corporation. Все права защищены.',
  },
  checklist: {
    title: 'Контрольный список ППТБ',
    create: 'создать новый',
    hideCode: 'скрыть код',
    code: 'Код',
    name: 'Название контрольного списка',
    emptyHierarchyChildrenMessage:
      '<p>Для этого <strong>{{parentLabel}}</strong> нет доступных <strong>{{childLabel}}</strong>.</p><p>Пожалуйста, добавьте новый(ую) <strong>{{childLabel}}</strong>, чтобы начать.</p>',
    edit: 'изменить',
    manage: 'управление',
    delete: 'удалить',
    defaultWalkthroughDisclaimer: 'Стандартный отказ от ответственности за подпись прохождения',
    defaultSummaryDisclaimer: 'Стандартный отказ от ответственности за подпись резюме',
    displayRichEditor: 'показать расширенный редактор',
    sampleText: 'образец текста',
    dialogs: {
      removeAccessHeader: 'Подтверждение',
      removeAccessMessage: 'Вы уверены, что хотите удалить [{{description}}]?',
    },
    confirmDelete:
      '<span>Вы уверены, что хотите удалить этот контрольный список?</span><br><br><span>Имя: {{ name }}<br>Описание: {{ description }}</span>',
    noChecklists: 'Нет доступных контрольных списков.',
    titleCreate: 'Создать контрольный список',
    createNew: 'Создать новый',
    selectPlaceholder: 'Выберите один вариант...',
    titleEdit: 'Редактировать контрольный список',
    titleDelete: 'Удалить контрольный список',
    deletedSuccessfully: 'Контрольный список успешно удален',
    importChecklist: 'Импорт контрольного списка',
    importChecklistTitle: 'Импорт контрольного списка в ',
    selectChecklistType: 'Выберите тип контрольного списка',
    confirm: 'Подтвердить',
    importSuccessMessage: 'Контрольный список успешно импортирован',
  },
  common: {
    yes: 'Да',
    no: 'Нет',
    na: 'Н/П',
    save: 'Сохранить',
    saving: 'Сохранение...',
    businessUnit: 'Подразделение',
    forbidActionErrorMessage: 'Пользователь не имеет права выполнять это действие.',
    name: 'Имя',
    code: 'Код',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    back: 'Назад',
    genericErrorMessage: 'Произошла непредвиденная ошибка. Пожалуйста, попробуйте позже.',
    errorOccurred: 'Произошла ошибка. Пожалуйста, попробуйте еще раз.',
    savedSuccessfully: 'Успешно сохранено',
    delete: 'удалить',
    deletedSuccessfully: 'Успешно удалено',
    edit: 'Редактировать',
    leaveWithOutSaving: 'Выйти без сохранения',
    language: 'Язык',
    month: 'Месяц',
    months: 'Месяцы',
    loading: 'Загрузка...',
    all: 'Все',
    recordAlreadyExists: 'Запись уже существует',
    recordCreatedSuccessfully: 'Запись успешно создана',
    createdSuccessfully: 'Успешно создано',
  },
  checklistManage: {
    title: 'Управление содержимым [{{ description }}]',
    sectionsTitle: 'Разделы',
    mandatoryLabel: 'Обязательный',
    createNewSubsectionAction: 'Создать новый подраздел',
    addSectionAction: 'добавить раздел',
    emptySubSectionsMessage: `<p>Для этого раздела нет доступного содержимого.</p>
      <p>Пожалуйста, добавьте подраздел, чтобы начать.</p>`,
    itemCodeTableHeader: 'Код',
    itemDescriptionTableHeader: 'Описание',
    createNewItemAction: 'Добавить вопрос',
    createSectionHeader: 'Создать новый раздел',
    editSectionHeader: 'Редактировать раздел',
    confirmDeleteSection: 'Вы уверены, что хотите удалить раздел <strong>{{description}}</strong>?',
    createSubSectionHeader: 'Создать подраздел',
    editSubSectionHeader: 'Редактировать подраздел',
    createChecklistItemTitle: 'Создать элемент контрольного списка',
    editChecklistItemTitle: 'Редактировать элемент контрольного списка',
    ShouldAddCommentToQuestion: 'Пользователь должен добавить комментарий к любому вопросу, на который дан ответ "Н/Д"',
    autoGenerateCodeLabel: 'Автоматически генерировать код',
    autoGenerateCodeplaceholder: 'Код будет сгенерирован автоматически',
    autoGenerateCodeInfo: 'Автоматическая генерация активирована, поле будет заполнено автоматически.',
    deleteChecklistItemTitle: 'Удалить элемент контрольного списка',
    confirmDeleteChecklistItem:
      '<span>Вы уверены, что хотите удалить этот элемент контрольного списка?</span><br><br><span><b>Код:</b> {{ name }}<br><b>Описание:</b> {{ description }}</span>',
    confirmDeleteSubSection: 'Вы уверены, что хотите удалить подраздел <strong>{{description}}</strong>?',
    deleteSectionHeader: 'Удалить раздел',
    deleteSubSectionHeader: 'Удалить подраздел',
    editQuestionTitle: 'Редактировать вопрос',
    sectionTypeLabel: 'Тип раздела',
    sectionTypePlaceholder: 'Выберите тип раздела',
    subSectionNameLabel: 'Название подраздела',
    itemTypeLabel: 'Тип',
    itemTypePlaceholder: 'выберите один',
    codePlaceholder: 'Введите код',
    duplicateCodeError: 'Этот код уже используется в другом разделе.',
    displayRichEditorLabel: 'Показать расширенный редактор',
    requireCommentForNA: 'Вы хотите потребовать комментарий для вопроса Н/Д?',
  },
  paginator: {
    previous: 'Предыдущий',
    next: 'Следующий',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} из {{totalRecords}}',
  },
  usersList: {
    title: 'Пользователи',
    forms: {
      displayInactiveUsers: 'показать неактивных пользователей',
      search: 'Поиск',
    },
    actions: {
      addNewUser: 'Добавить нового пользователя',
      grantAccess: 'предоставить доступ',
      reimportAllSharedUsers: 'Переимпортировать всех общих пользователей',
    },
    table: {
      fullName: 'полное имя',
      email: 'электронная почта',
      admin: 'администратор',
      type: 'Тип',
    },
    noUsers: 'Нет доступных пользователей',

    dialogs: {
      removeAccessHeader: 'Подтверждение',
      removeAccessMessage: 'Вы уверены, что хотите удалить доступ для: [{{fullName}}]?',
      addUserHeader: 'Добавить нового пользователя',
      editUserHeader: 'Редактировать пользователя',
      reimportSharedUsersHeader: 'Переимпортировать всех общих пользователей',
      reimportSharedUsersMessage:
        'Вы собираетесь обновить конфигурацию всех общих пользователей.<br> Эта операция может занять несколько минут.',
    },
    messages: {
      importSharedUsersFailed: 'Импорт не удался',
      importSharedUsersIncompleted: 'Импорт не завершен',
      importSharedUsersCompleted: 'Импорт завершен за: {{ minutes }} мин',
      pleaseWaitUntilProcessEnds: 'Дождитесь завершения процесса импорта. Не закрывайте и не покидайте эту страницу.',
      importInProgress: 'Идет импорт. Пожалуйста, дождитесь завершения перед закрытием страницы.',
      calculatingProgress: 'Расчет прогресса...',
    },
    labels: {
      imported: 'Импортировано',
      notFound: 'Не найдено',
      errors: 'Ошибки',
      total: 'Всего',
    },
  },
  actionItems: {
    title: 'Пункты действия',
    addActionItem: 'добавить пункт действия',
    noActionItems: 'Нет доступных пунктов действия',
    canOnlyPerformAttachments:
      'Вы можете управлять только вложениями файлов. Другие свойства пункта действия не могут быть изменены.',
    actionTitle: 'Заголовок',
    assignee: 'Исполнитель',
    date: 'Дата',
    dueDate: 'Срок выполнения',
    category: 'Категория',
    primaryCategory: 'Основная категория',
    secondaryCategory: 'Дополнительная категория',
    subcategory: 'Подкатегория',
    id: '№',
    comment: 'Комментарий',
    editComment: 'Редактировать Комментарий',
    commentRequiredWhenClosed: 'Комментарий обязателен, когда статус установлен на «Закрыто»',
    priority: 'Приоритет',
    assignTo: 'Назначить',
    pssrCccMembers: 'Участники {{pssrTitle}}',
    chevronDirectory: 'Справочник Chevron',
    userGroup: 'Группа пользователей',
    other: 'Другое',
    status: 'Статус',
    statusNames: {
      Open: 'Открыт',
      Closed: 'Закрыт',
      Cancel: 'Отменён',
      Rejected: 'Отклонён',
    },
    createdBy: 'Создано',
    updatedDate: 'Дата обновления',
    updatedBy: 'Обновлено',
    selectOne: 'Выберите...',
    typeNameOrEmail: 'Введите имя или email...',
    inactive: 'Неактивен',
    reopen: 'Открыть снова',
    reject: 'Отклонить',
    rejectReason: 'Причина отклонения',
    rejectReasonPlaceholder: 'Введите причину отклонения',
    timeCaptured: 'Время записи',
    attachments: 'Вложения',
    pssrFiles: 'Файлы ППТБ',
    links: 'Ссылки',
    fileUpload: 'Загрузка файла',
    attachFiles: 'Прикрепить (документы, изображения и т.д.)',
    fileTooLarge: 'Файл \'{{name}}\' превышает максимально допустимый размер {{max}}.',
    invalidFileFormat: 'Файл \'{{name}}\' имеет неподдерживаемый формат.',
    duplicateFile: 'Файл \'{{name}}\' уже был добавлен.',
    linkPlaceholder: 'www.example.com',
    dialogs: {
      configureActionItem: 'Составить пункт действия',
      configureComment: 'Комментарий',
      deleteActionItemHeader: 'Удалить ПД',
      deleteActionItemMessage: 'Вы уверены, что хотите выполнить это действие?',
      rejectActionItemHeader: 'Отклонить Пункт Действия',
      confirmPriorityChangeHeader: 'Подтвердить Изменение Приоритета',
      confirmPriorityChangeMessage: 'Вы уверены, что хотите изменить приоритет этого элемента действия?',
      deleteAttachmentHeader: 'Удалить Вложение',
      deleteAttachmentMessage: 'Вы уверены, что хотите удалить это вложение?',
    },
    messages: {
      deleteSuccess: 'Пункт действия успешно удален',
      reopenSuccess: 'Пункт действия успешно открыт снова',
      rejectSuccess: 'Пункт действия успешно отклонен',
      rejectReasonRequired: 'Причина отклонения обязательна',
      confirmReject: 'Вы уверены, что хотите отклонить этот пункт действия? Он будет {{action}}.',
      confirmRejectP4: 'Вы уверены, что хотите отклонить этот пункт действия?',
      returnToTeamLead: 'возвращен Руководителю Команды',
      confirmReopen: 'Вы уверены, что хотите открыть снова этот пункт действия?',
    },
  },
  actionItemsList: {
    title: 'Пункты Действий',
    sections: {
      location: 'Местоположение',
      pssr: 'PSSR',
      actionItem: 'Пункт Действия',
    },
    fields: {
      area: 'Область',
      facilityOperationTeam: 'Операционная Команда Объекта',
      facility: 'Объект',
      titleStatus: 'Статус Названия',
      type: 'Тип',
      title: 'Название',
      project: 'Проект',
      template: 'Шаблон',
      leadFinalApprover: 'Руководитель/Окончательный Утверждающий',
      showOnlyDeletedPssr: 'Показывать Только Удаленные PSSR',
      status: 'Статус',
      priority: 'Приоритет',
      assignedTo: 'Назначено',
      autoLoadImages: 'Автоматическая Загрузка Изображений',
    },
    placeholders: {
      selectOne: 'выберите один',
      sampleText: 'образец текста',
      no: 'Выбрать Нет',
    },
    priorityDescriptions: {
      p3: 'Пункт должен быть завершен до запуска',
      p4: 'Пункт будет завершен после запуска',
      p5: 'Пункт должен быть завершен до запуска',
    },
    priorityLegend: {
      title: 'Приоритеты элементов действий',
    },
    actions: {
      clearFilter: 'очистить фильтр',
      exportExcel: 'экспортировать excel',
      noDataToExport: 'Нет элементов действия для экспорта',
    },
    imageAltText: 'Изображение Элемента Действия',
    pssrTeamLead: 'Руководитель Команды PSSR',
    finalApprover: 'Окончательный Утверждающий',
    subsection: 'Подраздел',
    code: 'Код',
    question: 'Вопрос',
    answer: 'Ответ',
    noData: 'Пункты действий недоступны',
    noDataFound: 'Пункты действий не найдены для выбранных фильтров',
  },
  responseSignature: {
    signedBy: 'Подписано',
    signedOn: 'Дата подписания',
    name: 'Имя',
    dateCaptured: 'Дата Создания',
    sign: 'Подписать',
    finalApproverLabel: 'Финальный Утверждающий',
    dialogs: {
      deleteHeader: 'Удалить подпись',
      deleteMessage: 'Вы собираетесь удалить подпись, пожалуйста, выберите подтвердить, чтобы продолжить',
      cancel: 'отменить',
      delete: 'удалить',
    },
  },
  comments: {
    title: 'Комментарии',
    addComment: 'добавить комментарий',
    dialogs: {
      configureComment: 'Комментарий',
      deleteCommentHeader: 'Удалить комментарий',
      deleteCommentMessage: 'Вы уверены, что хотите выполнить это действие?',
    },
    comment: 'Комментарий',
  },
  userType: {
    Chevron: 'Chevron',
    External: '3rd Party (внешний)',
    Shared: 'Общий',
  },
  areas: {
    title: 'Зона',
    showDeletedItems: 'Показать удалённые элементы',
    areaListTitle: 'Список зон',
    createFacilityOperationTeam: 'Создать новую команду эксплуатации объекта',
    createFacility: 'Создать новый объект',
    restore: 'Восстановить',
    emptySubAreaMessage:
      '<p>Для этой зоны нет доступного содержимого.</p><p>Пожалуйста, добавьте новую команду эксплуатации объекта, чтобы начать.</p>',
    emptyHierarchyChildrenMessage:
      '<p>Для этого <strong>{{parentLabel}}</strong> нет доступных <strong>{{childLabel}}</strong>.</p><p>Пожалуйста, добавьте новый(ую) <strong>{{childLabel}}</strong>, чтобы начать.</p>',
    emptyAreaMessage:
      '<p>Для этого бизнес-подразделения нет доступного содержимого.</p><p>Пожалуйста, добавьте новую зону, чтобы начать.</p>',
    subareaTitle: 'Команда эксплуатации объекта',
    facilityTitle: 'Объект',
    removeConfirmationHeader: 'Подтверждение',
    confirmDeleteArea: 'Вы уверены, что хотите удалить зону <strong>{{description}}</strong>?',
    confirmDeleteSubarea:
      'Вы уверены, что хотите удалить команду эксплуатации объекта <strong>{{description}}</strong>?',
    confirmDeleteFacility: 'Вы уверены, что хотите удалить объект <strong>{{description}}</strong>?',
    restoredSuccessfully: 'Успешно восстановлено',
  },
  pssrImport: {
    title: 'Импорт MOC',
    sections: {
      import: 'Импорт',
    },
    forms: {
      labels: {
        application: 'Приложение',
        pssrId: 'ID',
        mocId: 'ID MOC',
        mocName: 'Название MOC',
      },
      placeholders: {
        application: 'выберите вариант',
        pssrId: 'Введите ID MOC',
        mocName: 'Автоматически из iMOC',
      },
      validation: {
        mocIdRequired: 'ID MOC обязателен',
        applicationRequired: 'Приложение обязательно',
      },
    },
    actions: {
      add: 'Добавить',
      addMoc: 'Добавить MOC',
      importAll: 'Импортировать Все',
      createPssr: 'создать PSSR',
      searchMoc: 'искать MOC',
      importMocCreatePssr: 'Импортировать MOC и создать PSSR',
    },
    table: {
      id: 'ID',
      pssrId: 'ID PSSR',
      name: 'Название',
      status: 'Статус',
    },
    summary: {
      records: 'Записи',
      imported: 'Импортировано',
      errors: 'Ошибки',
    },
    status: {
      pending: 'Ожидание',
      inProgress: 'В процессе',
      imported: 'Импортировано',
      warning: 'Предупреждение',
      error: 'Ошибка',
    },
    messages: {
      alreadyInList: 'ID PSSR уже есть в списке импорта.',
      pssrNotFound: 'PSSR не найден.',
    },
  },
  pssrCreate: {
    title: 'Создать PSSR',
    sections: {
      generalInformation: 'Общая Информация',
      location: 'Местоположение',
      details: 'Детали',
      instructions: 'Инструкции',
    },
    forms: {
      labels: {
        title: 'Название',
        moc: 'MOC',
        wo: 'WO',
        description: 'Описание',
        area: 'Зона',
        facilityOperationTeam: 'Операционная Команда Объекта',
        facility: 'Объект',
        project: 'Проект',
        template: 'Шаблон',
        type: 'Тип',
        organization: 'Организация',
        subArea: 'Подзона',
        includeProjectTeam: 'Включить членов команды проекта',
      },
      placeholders: {
        title: 'образец текста',
        moc: 'образец текста',
        wo: 'образец текста',
        description: 'Введите описание',
        area: 'выберите один',
        facilityOperationTeam: 'выберите один',
        facility: 'выберите один',
        project: 'выберите один',
        template: 'выберите один',
        type: 'выберите один',
        subArea: 'выберите один',
      },
      validation: {
        titleRequired: 'Название обязательно',
        mocRequired: 'MOC обязателен',
        woRequired: 'WO обязателен',
        businessUnitRequired: 'Бизнес-единица обязательна',
        organizationRequired: 'Организация обязательна',
        areaRequired: 'Зона обязательна',
        facilityOperationTeamRequired: 'Операционная команда объекта обязательна',
        facilityRequired: 'Объект обязателен',
        projectRequired: 'Проект обязателен',
        templateRequired: 'Шаблон обязателен',
        typeRequired: 'Тип обязателен',
        requiredFieldsMessage:
          'Примечание: Пожалуйста, заполните поля, отмеченные как обязательные. Нажмите Сохранить.',
      },
      templateChangeConfirmTitle: 'Изменить шаблон',
      templateChangeConfirmMessage: 'Изменение шаблона обновит разделы PSSR. Вы уверены, что хотите изменить шаблон?',
    },
    actions: {
      create: 'создать',
      pullFromKMS: 'Извлечь из КЗУ',
    },
    successMessage: 'PSSR успешно создан',
  },
  pssrKms: {
    title: 'PSSR из КЗУ',
    sections: {
      generalInformation: 'Общая Информация',
      pssrInformation: 'Информация PSSR',
      location: 'Местоположение',
      details: 'Детали',
    },
    kmsInstruction:
      'Найдите конкретный номер MOC или отфильтруйте список по статусу и размеру страницы для импорта данных из КЗУ.',
    searchMOCNumber: 'Поиск Номера MOC',
    mocPattern: 'напр., MOC-2024-123',
    invalidMOCFormat: 'Неверный формат MOC. Пример: MOC-2024-123',
    search: 'Поиск',
    filterByStatus: 'Фильтр Списка КЗУ по Статусу',
    filterPageSize: 'Фильтр Количества Возвращаемых Элементов КЗУ',
    selectFromList: 'Выбрать из Списка MOC КЗУ',
    selectKMSItems: 'Выбрать элементы КЗУ',
    createNew: 'Создать Новый',
    enterName: 'Введите имя',
    add: 'Добавить',
    enterProjectNumber: 'Введите номер проекта',
    selectQAQCEvent: 'Выбрать событие QAQC',
    selectFromQAQC: 'Выбрать из QAQC',
    milestones: 'Контрольные Точки',
    workOrders: 'Наряды на Работу',
    selectMilestone: 'Выбрать контрольную точку',
    selectWorkOrder: 'Выбрать наряд на работу',
    milestoneWorkOrders: 'Наряды на Работу Контрольных Точек',
    note: 'Примечание',
    fillRequiredFields: 'Пожалуйста, заполните поля, отмеченные как обязательные',
    generatePSSRs: 'Создать PSSR',
    successMessage: 'PSSR из КЗУ успешно создан',
    multipleSuccessMessage: 'Несколько PSSR из КЗУ успешно созданы',
    loadingKMSItemsError: 'Ошибка загрузки элементов КЗУ. Попробуйте еще раз.',
    selectKMSItemsWarning: 'Пожалуйста, выберите хотя бы один элемент КЗУ',
    kmsStatus: {
      draft: 'Черновик',
      processActivated: 'Процесс Активирован',
      reviewInProgress: 'Рассмотрение в Процессе',
      implementationInProgressEdit: 'Реализация в Процессе Редактирование',
      changeRequestApproved: 'Запрос на Изменение Одобрен',
      changeRequestDenied: 'Запрос на Изменение Отклонен',
      implementationInProgress: 'Реализация в Процессе',
      readyToStartUp: 'Готов к Запуску',
      completed: 'Завершен',
      canceled: 'Отменен',
      onHold: 'На Удержании',
    },
    businessUnit: 'Бизнес-Подразделение',
    selectPlaceholder: 'Выберите один',
  },
  pssrSubSections: {
    actions: {
      addQuestion: 'Добавить вопрос',
    },
  },
  pssrDetails: {
    title: 'Детали PSSR',
    pssrId: 'ID PSSR',
    sections: {
      generalInformation: 'Общая Информация',
      location: 'Местоположение',
      details: 'Детали',
      sectionsTitle: 'Разделы',
      actionItems: 'Пункты действия',
      comments: 'Комментарии',
      enableCustomOrderForSections: 'Включить настраиваемый порядок разделов',
      sectionsLegendTitle: 'Легенда разделов',
      hideCompletedQuestions: 'Скрыть завершённые вопросы',
      saveSectionOrder: 'Сохранить порядок разделов',
      confirmRemoveSectionTitle: 'Удалить раздел',
      confirmRemoveSectionDescription: 'Вы уверены, что хотите удалить {{description}}?',
      sectionNameLabel: 'Название раздела',
      sectionNamePlaceholder: 'Введите название раздела',
      editSectionName: 'Редактировать название раздела',
      addMultipleSectionName: 'Добавить множественный раздел',
      validation: {
        sectionNameRequired: 'Название раздела обязательно',
        sectionNameDuplicated: 'Раздел с таким названием уже существует',
      },
      toast: {
        unableToCompleteOperation: 'Не удалось завершить операцию',
        saveCompletedTitle: 'Сохранение завершено',
        sectionsSortedSuccessfully: 'Разделы успешно отсортированы',
        loadSectionsError: 'Ошибка при загрузке разделов. Пожалуйста, попробуйте снова.',
        userAlreadyAdded: 'Пользователь уже добавлен в этот раздел',
        userAddedSuccessfully: 'Пользователь успешно добавлен',
        sectionAddedSuccessfully: 'Раздел успешно добавлен',
        sectionUpdatedSuccessfully: 'Раздел успешно обновлён',
      },
      selectLead: 'Выбрать ответственного',
      section1Title: 'Раздел 1',
      legend: {
        defaultQuestionLabel: 'вопрос по умолчанию',
        defaultQuestionDescription: 'вопрос, на который можно ответить да, нет или н/д',
        optionalLabel: 'необязательно',
        optionalDescription: 'можно добавить вручную в PSSR',
        multipleLabel: 'множественный',
        multipleDescription: 'необязательно, но можно добавить несколько раз в PSSR',
        mandatoryLabel: 'обязательно',
      },
      instructions: 'Инструкции',
      history: 'История изменений PSSR',
      attachments: 'Вложения PSSR',
    },
    subsections: {
      actionItemNeeded: 'Примечание: Требуется элемент действия для завершения вопросов.',
    },
    questions: {
      code: 'Код',
      question: 'Вопрос',
      answer: 'Ответ',
      updatedBy: 'Обновлено',
      updatedDate: 'Дата Обновления',
      clearAnswer: 'очистить ответ',
      deleteQuestion: 'удалить вопрос',
      answerUpdated: 'Ответ успешно обновлён',
      answerCleared: 'Ответ успешно очищен',
      questionDeleted: 'Вопрос успешно удалён',
      confirmDeleteTitle: 'Удалить Вопрос',
      confirmDeleteMessage: 'Вы уверены, что хотите удалить этот вопрос: {{question}}?',
      validation: {
        actionItemIsNeeded: 'Для завершения вопроса требуется элемент действия',
        commentIsNeeded: 'Для завершения вопроса требуется комментарий',
        signatureIsNeeded: 'Для завершения вопроса требуется подпись',
        responseIsNeeded: 'Для завершения вопроса требуется ответ',
        actionItemsClosedOrCancelledNeeded:
          'Для завершения вопроса требуются закрытые или отменённые элементы действия {{P3Label}}',
      },
    },
    forms: {
      labels: {
        title: 'Название',
        moc: 'MOC',
        wo: 'WO',
        description: 'Описание',
        area: 'Зона',
        facilityOperationTeam: 'Операционная Команда Объекта',
        facility: 'Объект',
        project: 'Проект',
        template: 'Шаблон',
        type: 'Тип',
      },
      placeholders: {
        title: 'образец текста',
        moc: 'образец текста',
        wo: 'образец текста',
        description: 'Введите описание',
        area: 'выберите один',
        facilityOperationTeam: 'выберите один',
        facility: 'выберите один',
        project: 'выберите один',
        template: 'выберите один',
        type: 'выберите один',
      },
      validation: {
        titleRequired: 'Название обязательно',
        businessUnitRequired: 'Бизнес-единица обязательна',
        organizationRequired: 'Организация обязательна',
        areaRequired: 'Зона обязательна',
        facilityOperationTeamRequired: 'Операционная команда объекта обязательна',
        facilityRequired: 'Объект обязателен',
        templateRequired: 'Шаблон обязателен',
        typeRequired: 'Тип обязателен',
        requiredFieldsMessage:
          'Примечание: Пожалуйста, заполните поля, отмеченные как обязательные. Нажмите Сохранить.',
      },
      templateChangeConfirmTitle: 'Изменить шаблон',
      templateChangeConfirmMessage: 'Изменение шаблона обновит разделы PSSR. Вы уверены, что хотите изменить шаблон?',
    },
    actions: {
      save: 'сохранить',
      saveGeneralInformation: 'сохранить общую информацию',
      showFullHistory: 'показать полную историю',
      showLessHistory: 'показать меньше истории',
      attachFile: 'Прикрепить файл (документы, изображения, чертежи psi и т.д.)',
      attachFileButton: 'прикрепить файл',
      printToPdf: 'печать в pdf',
      sendEmailReminder: 'отправить напоминание по электронной почте',
      importMocActionItems: 'импортировать элементы действий moc',
      sendToMocStartup: 'отправить в запись moc для утверждения запуска',
      returnToTeamLead: 'вернуть руководителю команды',
      start: 'начать pssr',
      reject: 'отклонить',
      delete: 'удалить',
      restorePssr: 'восстановить pssr',
      reopen: 'открыть заново',
    },
    mocImportedHint: 'Этот PSSR был импортирован. Вы не можете изменить его идентификатор',
    history: {
      reason: 'Причина',
      by: 'Кем',
      draftCreated: 'Черновик Создан',
      initiated: 'Инициировано',
      started: 'Начато',
      completed: 'Завершено',
      pendingApproval: 'Ожидание Утверждения',
      verbalApproval: 'Устное Утверждение',
      approved: 'Утверждено',
      rejected: 'Отклонено',
      restored: 'Восстановлено',
      deleted: 'Удалено',
      closed: 'Закрыто',
    },
    successMessage: 'PSSR успешно обновлен',
    pdfDownloadSuccess: 'PDF успешно загружен',
    pssrDeletedSuccess: 'PSSR успешно удален',
    pssrReopenedSuccess: 'PSSR успешно переоткрыт',
    statusChangedSuccess: 'Статус PSSR успешно изменен',
    pssrRejectedSuccess: 'PSSR успешно отклонен',
    pssrRestoredSuccess: 'PSSR успешно восстановлен',
    importMOCActionsSuccess: 'Элементы действий MOC успешно импортированы',
    sendToMOCSuccess: 'Успешно загружено в MOC',
    emailSentSuccess: 'Напоминание по электронной почте успешно отправлено',
    importMOCActionsNone: 'Нет элементов действий MOC для импорта',
    lastSent: 'Последняя Отправка',
    messages: {
      questionAdded: 'Вопрос успешно добавлен',
    },
    dialogs: {
      addQuestion: {
        descriptionLabel: 'Описание',
        descriptionPlaceholder: 'Введите описание вопроса',
        descriptionRequired: 'Описание обязательно',
      },
    },
    rejectDialog: {
      title: 'Отклонить PSSR',
      reasonLabel: 'Причина Отклонения',
      cancel: 'Отмена',
      confirm: 'Отклонить',
    },
    emailReminderDialog: {
      title: 'Отправить Напоминание по Электронной Почте',
      sendReminder: 'Отправить Напоминание',
      sendMessage: 'Отправить Пользовательское Сообщение',
      reminderInstructions:
        'Отправить напоминание назначенным лицам для всех открытых AI. Когда PSSR находится в статусе ожидания утверждения, утверждающие получат уведомление.',
      messageInstructions: 'Отправить письмо всем участникам PSSR',
      enterText: 'Введите ваше сообщение...',
      cancel: 'Отмена',
      confirm: 'Отправить',
    },
    commentDialog: {
      title: 'Комментарий',
      commentLabel: 'Комментарий',
      commentPlaceholder: 'образец текста',
      createdBy: 'Создано',
      updatedDate: 'Дата обновления',
      updatedBy: 'Обновлено',
      documents: 'Документы',
      delete: 'удалить',
      cancel: 'отмена',
      save: 'сохранить',
      successMessage: 'Комментарий успешно обновлен',
      confirmDeleteAttachment: 'Вы уверены, что хотите удалить это вложение?',
      confirmDeleteAttachmentHeader: 'Удалить вложение',
      commentRequired: 'Комментарий обязателен',
      addComment: 'Добавить Комментарий',
      editComment: 'Редактировать Комментарий',
      confirmDelete: 'Вы уверены, что хотите удалить этот комментарий?',
      confirmDeleteHeader: 'Удалить Комментарий',
      commentAdded: 'Комментарий успешно добавлен',
      commentUpdated: 'Комментарий успешно обновлен',
      commentDeleted: 'Комментарий успешно удален',
    },
    confirmDeleteHeader: 'Подтвердить удаление',
    confirmDeleteMessage: 'Вы собираетесь удалить этот элемент. Хотите продолжить?',
    confirmDeleteComment: 'Вы уверены, что хотите удалить этот комментарий?',
    commentDeletedSuccess: 'Комментарий успешно удален',
    changeStatusHeader: 'Подтвердить Изменение Статуса',
    confirmChangeStatus: 'Вы хотите изменить статус?',
    confirmReturnToTeamLead: 'Вы хотите вернуть этот PSSR Руководителю Группы?',
    confirmRejectHeader: 'Подтвердить Отклонение',
    confirmRejectMessage: 'Вы уверены, что хотите отклонить этот PSSR?',
    confirmReopenHeader: ' ',
    confirmReopenMessage: 'Вы уверены, что хотите переоткрыть этот PSSR?',
    comments: {
      title: 'Комментарии',
      addComment: 'добавить комментарий',
      noComments: 'Комментарии не добавлены',
      by: 'от',
      on: 'на',
    },
    validation: {
      onlyPSSRTeamLeadcanInitiatePSSR: 'Только Руководитель группы ППТБ может инициировать ППТБ',
      requireFinalApproverBeforeInitiation: 'Для инициации ППТБ потребуется Финальный Утверждающий',
      pssrMustAnswerAllQuestionsToCompleteWalkdown: 'Для завершения обхода, ответьте на все вопросы и добавьте подписи',
      pssrMustHaveFinalApproverToCompleteWalkdown: 'Для выполнения обхода, в ППТБ должен быть последний утверждающий',
      onlyPSSRTeamLeadcanSubmitforPendingApproval:
        'Только руководитель группы ППТБ может подать на ожидание утверждения',
      p3ActionItemsMustBeClosed: 'Необходимо закрыть все замечания категории P3',
      p4ActionItemsMustBeClosed: 'Необходимо закрыть все замечания категории P4',
      onlyFinalApprovercanApprovePSSR: 'Только последний утверждающий может утвердить ППТБ',
      onlyPSSRTeamLeadClosePSSR: 'Только руководитель группы ППТБ может закрыть ППТБ',
    },
  },
  pdfDialog: {
    header: 'Прикрепить PDF-файл',
    selectTypePrompt: 'Как вы хотите прикрепить этот PDF?',
    document: 'Документ',
    image: 'Изображение',
    selectPagesTitle: 'Выберите страницы для преобразования в изображения',
    allPages: 'Все страницы',
    selectPages: 'Выбрать страницы',
    page: 'Страница',
    select: 'Выбрать',
    couldNotDetectPages: 'Не удалось определить количество страниц. Будут включены все страницы.',
  },
  attachmentUpload: {
    title: 'Прикрепить Файл',
    selectType: 'Что вы хотите прикрепить?',
    types: {
      link: 'Ссылка',
      document: 'Документ',
      image: 'Изображение',
    },
    forms: {
      url: 'URL',
      urlPlaceholder: 'https://пример.com',
    },
    clickToSelect: 'Нажмите, чтобы выбрать файл',
    acceptedImageTypes: 'Принимаемые форматы: JPG, PNG, GIF и т.д.',
    acceptedDocumentTypes: 'Принимаемые форматы: PDF, DOC, DOCX, XLS, XLSX',
    upload: 'Загрузить',
    successMessage: 'Файл успешно прикреплен',
    sections: {
      images: 'Изображения',
      documents: 'Документы',
      links: 'Ссылки',
    },
    uploaded: 'Загружено',
    download: 'Скачать',
  },
  organizationsList: {
    title: 'Организации',
    tableHeader: 'организация',
    noOrganizations: 'Нет доступных организаций',
    successCreated: 'Организация успешно создана',
    actions: {
      addNew: 'добавить новую организацию',
    },
    forms: {
      name: 'Название организации',
      namePlaceholder: 'тип организации название',
    },
    dialogs: {
      addNew: 'Добавить новую организацию',
      edit: 'Редактировать организацию',
      deleteHeader: 'Удалить организацию',
      deleteMessage: 'Вы уверены, что хотите удалить организацию: [{{name}}]?',
    },
  },
  userGroupsList: {
    title: 'Группы пользователей пунктов действия',
    groupsSection: 'Группы',
    noUsers: 'В этой группе нет пользователей',
    noGroups: 'Нет доступных групп',
    selectGroup: 'Выберите группу для просмотра пользователей',
    actions: {
      create: 'создать',
      addNewUser: 'добавить нового пользователя',
      selectUser: 'Выбрать пользователя',
      changeUser: 'Изменить пользователя',
      add: 'Добавить',
    },
    table: {
      userName: 'имя пользователя',
      email: 'электронная почта',
    },
    forms: {
      namePlaceholder: 'Введите название группы',
      selectUserPrompt: 'Пожалуйста, выберите пользователя для добавления в эту группу',
      selectedUser: 'Выбранный пользователь',
    },
    dialogs: {
      addGroup: 'Добавить новую группу',
      editGroup: 'Редактировать группу',
      deleteGroupHeader: 'Удалить группу',
      deleteGroupMessage: 'Вы уверены, что хотите удалить группу: [{{name}}]?',
      removeUserHeader: 'Удалить пользователя',
      removeUserMessage: 'Вы уверены, что хотите удалить {{name}} из этой группы?',
      addUser: 'Добавить пользователя в группу',
      selectUser: 'Выбрать пользователя',
    },
  },
  participants: {
    title: 'Участники',
    addParticipant: 'добавить участника',
    addMember: 'Член ватсаны',
    pssrTeamLead: 'Руководитель команды {{pssrTitle}}',
    pssrTeam: 'Команда {{pssrTitle}}',
    projectManagers: 'Менеджеры проектов',
    projectTeamMembers: 'Члены команды проекта',
    operationsRepresentative: 'Представитель операций',
    finalApprover: 'Окончательный утверждающий',
    actionItemAssignee: 'Исполнитель пункта действий',
    noParticipantsAdded: 'Участники не добавлены',
    signedBy: 'подписано',
    signedInBehalfOf: 'подписано от имени',
    signedOn: 'дата подписания',
  },
  qaqcImport: {
    title: 'Импорт QAQC',
    milestone: 'Веха QAQC',
    workOrders: 'Рабочие заказы QAQC',
    milestoneWorkOrders: 'Рабочие заказы вехи QAQC (необязательно)',
    milestoneWorkOrdersLabel: 'Рабочие заказы вехи QAQC',
    milestoneWorkOrdersMessage: 'Выберите 1 веху, чтобы просмотреть рабочие заказы в рамках этой вехи',
    noItemsAvailable: 'Нет доступных вех/рабочих заказов из QAQC',
    noWorkOrdersForMilestone: 'Для этой вехи нет доступных рабочих заказов',
    unableLoadItems: 'Не удалось связаться с системой QAQC для вех/рабочих заказов, повторите попытку позже',
    loadEventsError: 'Ошибка получения {{eventLabel}} из QAQC',
    multipleMilestonesWarning: 'Выберите 1 этап, чтобы просмотреть рабочие задания в рамках этого этапа.',
    generatePssrTitle: 'Создать заголовок PSSR',
    alreadyExists: 'Это событие QAQC уже существует как проект',
    selectEvent: 'Проект',
    sections: 'Разделы',
    assignSectionLeads: 'Назначить руководителей разделов',
    selectLead: 'Выбрать руководителя',
    sectionName: 'Название раздела',
    lead: 'Ответственный',
    template: 'Шаблон',
    type: 'Тип',
    projectType: 'Тип проекта',
    successMessage: 'Импорт QAQC завершён. Проект и PSSRs созданы.',
    errorMessage: 'Ошибка при создании проекта QAQC. Попробуйте снова.',
    projectCreatedWithoutItems:
      'Проект создан. В QAQC пока нет вех и рабочих заказов; используйте "Загрузить новые элементы QAQC", когда они появятся.',
    partialErrorMessage:
      'Проект создан, но его PSSR создать не удалось. Используйте "Загрузить новые элементы QAQC", чтобы повторить попытку.',
    somePssrsNotCreated:
      'Создано только {{created}} из {{total}} PSSR. Используйте "Загрузить новые элементы QAQC", чтобы создать остальные.',
  },
  participantDialog: {
    title: 'Выбрать участника',
    addParticipant: 'Добавить Участника',
    selectUserType: 'Выберите тип пользователя',
    selectedUserType: 'Выбранный тип пользователя',
    chevronDirectory: 'каталог chevron/общие пользователи',
    newNonChevron: 'новый не chevron',
    searchPlaceholder: 'Поиск по email...',
    emailPlaceholder: 'Введите email...',
    namePlaceholder: 'Введите имя...',
    selectRole: 'Выберите роль',
    selectedRole: 'Выбранная роль',
    selectOne: 'выберите один',
    add: 'добавить',
    stagedParticipants: 'для добавления:',
    batchLimitReached: 'достигнут лимит {{limit}} пользователей, выберите добавить',
    alreadyStagedError: 'этот пользователь уже в списке',
    successMessage: 'Участник успешно добавлен',
    added: 'Участник успешно добавлен',
    addError: 'Ошибка при добавлении участника',
    alreadyParticipantPssr: 'Этот пользователь уже является участником этого ППТБ как {{role}}',
    alreadyMemberProject: 'Этот пользователь уже является членом этого проекта как {{role}}',
  },
  participantEditDialog: {
    title: 'Редактировать участника',
    user: 'Пользователь',
    selectRole: 'Выбрать роль',
    delete: 'удалить',
    captureSignature: 'захватить подпись',
    recaptureSignature: 'повторно захватить подпись',
    removeSignature: 'удалить подпись',
    removeSignatureSuccess: 'Подпись успешно удалена',
    save: 'сохранить',
    noSignature: 'Подпись не захвачена',
    successMessage: 'Участник успешно обновлён',
    deleteSuccessMessage: 'Участник успешно удалён',
    deleteConfirmHeader: 'Удалить участника',
    deleteConfirmMessage: 'Вы уверены, что хотите удалить этого участника?',
  },
  buAdminsList: {
    title: 'Администраторы БП',
    actions: {
      addNewUser: 'добавить администратора',
      delete: 'удалить',
    },
    table: {
      fullName: 'полное имя',
      email: 'электронная почта',
    },
    noAdmins: 'Нет доступных пользователей-администраторов',
  },
  externalUserForm: {
    labels: {
      firstName: 'Имя',
      lastName: 'Фамилия',
      email: 'Email',
      userNameEmail: 'Имя пользователя или email',
    },
  },
  sharedUserForm: {
    labels: {
      sharedUserGroup: 'Общая группа пользователей',
      sharedEmail: 'Общий email',
    },
    actions: {
      addChildUser: 'добавить пользователя',
      importSharedUsers: 'Импортировать общих пользователей',
    },
    whitePages: {
      title: 'Интеграция с White Pages',
      description:
        'Используйте этот тип общего email, если вам нужно синхронизироваться с White Pages. Список пользователей будет автоматически обновляться со временем. Некоторые пользователи могут быть автоматически добавлены или удалены из этого общего email.',
    },
    customConfiguration: {
      title: 'Пользовательская конфигурация',
      description: 'Управляйте списком пользователей вручную.',
    },
  },
  pssrsList: {
    title: 'ППТБ',
    location: 'Местоположение',
    details: 'Детали',
    emptyMessage: 'ППТБ не найдены',
    searchByLocation: 'Местоположение',
    searchByDetails: 'Детали',
    filters: {
      businessUnit: 'Деловая единица',
      organization: 'Организация',
      area: 'Область',
      subArea: 'Подобласть',
      facilityOperationTeam: 'Операционная группа объекта',
      facility: 'Объект',
      project: 'Проект',
      template: 'Шаблон',
      selectOne: 'выберите один',
      status: 'Статус',
      type: 'Тип',
      deletedStagnant: 'Удален/Затухание',
      showOnlyDeleted: 'показывать только удалённые ППТБ',
      showOnlyStagnant: 'показывать только стагнирующие ППТБ',
      search: 'Поиск',
      placeholderSearch: 'поиск по moc, wo, id пптб, названию и т.д...',
      userSearch: 'Поиск пользователя',
      placeholderUserSearch: 'sample text',
      isStagnant: 'Это затухание',
      isDeleted: 'Это удалено',
    },
    buttons: {
      clearFilter: 'очистить фильтр',
      newPssr: 'новый ППТБ',
      viewItems: 'просмотр элементов',
      open: 'открыть',
    },
    actions: {
      clearFilter: 'Очистить фильтр',
      newPssr: 'Новый ППТБ',
      importPssr: 'Импорт ППТБ',
    },
    table: {
      id: 'ID',
      title: 'Название',
      type: 'Тип',
      status: 'Статус',
      facility: 'Объект',
      project: 'Проект',
    },
    statusOptions: {
      draft: 'Черновик',
      initiated: 'Инициирован',
      inProgress: 'Выполняется',
      completed: 'Завершён',
      pendingApproval: 'Ожидает утверждения',
      approved: 'Утверждён',
      closed: 'Закрыт',
    },
    noPssrs: 'ППТБ не найдены',
  },
  pssrListItem: {
    pssrId: 'ИДЕНТИФИКАТОР ППТБ',
    pssr: 'ППТБ',
    moc: 'MOC',
    wo: 'WO',
    project: 'Проект',
    teamLeads: 'Руководители команд',
    totalQuestions: 'Всего вопросов',
    outstandingQuestions: 'Неразрешенные вопросы',
    completedQuestions: 'Завершенные вопросы',
    area: 'Область',
    subArea: 'Подобласть',
    facility: 'Объект',
    qaqcStatus: 'Статус QAQC',
    qaqcMilestone: 'Этап QAQC',
    qaqcWorkOrder: 'Рабочий наряд QAQC',
    qaqcReady: '% готово',
    qaqcComplete: '% завершено',
    qaqcAccepted: '% принято',
    qaqcSignatures: 'Подписи',
    qaqcDocuments: 'Документы QAQC',
    qaqcNoData: 'Нет данных QAQC',
  },
  pssrStatuses: {
    Draft: 'Черновик',
    Initiated: 'Инициировано',
    InProgress: 'В процессе',
    Completed: 'Завершено',
    PendingApproval: 'Ожидает утверждения',
    Approved: 'Утверждено',
    Closed: 'Закрыто',
    Deleted: 'Удалено',
    CreateDate: 'Черновик Создан',
    InitiatedOn: 'Инициировано',
    StartedOn: 'В процессе с',
    CompletedOn: 'Обход Завершен',
    PendingApprovalOn: 'Утверждение Ожидает Отправки',
    ApprovedOn: 'Утверждено',
    ClosedOn: 'Закрыто',
    DeletedOn: 'Удалено',
    RestoredOn: 'Восстановлено',
  },
  signatureCaptureDialog: {
    title: 'Захватить подпись',
    confirm: 'подтвердить',
    saveSuccess: 'Подпись успешно захвачена',
  },
  projectsList: {
    title: 'Проекты',
    table: {
      projectName: 'название проекта',
      projectManager: 'менеджер проекта',
      status: 'статус',
      completedTotalPssrs: 'выполнено/всего пптб',
      actions: 'действия',
      dateCreated: 'дата создания',
    },
    statusLabels: {
      active: 'активный',
      closed: 'закрытый',
    },
    sort: {
      placeholder: 'Сортировать по',
      nameAsc: 'Имя (А-Я)',
      nameDesc: 'Имя (Я-А)',
      statusAsc: 'Статус (От Низкого к Высокому)',
      statusDesc: 'Статус (От Высокого к Низкому)',
      dateAsc: 'Дата Создания (Самые Старые)',
      dateDesc: 'Дата Создания (Самые Новые)',
    },
    actions: {
      open: 'открыть',
      createProject: 'создать проект',
    },
    projectSearch: 'Поиск проекта',
    showDeletedProjects: 'Показать удаленные проекты',
    searchPlaceholder: 'Поиск по имени',
    datePlaceholder: 'мм/дд/гггг - мм/дд/гггг',
    statusPlaceholder: 'выберите один',
    noProjects: 'Нет доступных проектов',
  },
  projectEdit: {
    title: 'Редактировать Проект',
    projectName: 'Название Проекта',
    projectNamePlaceholder: 'Введите название проекта',
    statusActive: 'активный',
    statusClosed: 'закрытый',
    statusDeleted: 'удален',
    teamMembers: 'Члены Команды',
    addParticipant: 'добавить участника',
    pssrCcc: 'ППТБ/ССС',
    newPssr: 'Новый {{pssrTitle}}',
    noPssrCcc: 'С этим проектом не связано ни одного ППТБ/ССС.',
    delete: 'удалить',
    markAsClosed: 'пометить как закрытый',
    reopen: 'переоткрыть',
    confirmDelete: 'Вы уверены, что хотите удалить этот проект?',
    confirmDeleteHeader: 'Подтвердить Удаление',
    confirmDeletePssrs: 'Вы также хотите удалить все ППТБ, связанные с этим проектом?',
    confirmDeletePssrsHeader: 'Удалить ППТБ?',
    deleteSuccess: 'Проект успешно удален',
    confirmMarkAsClosed: 'Вы уверены, что хотите пометить этот проект как закрытый?',
    confirmMarkAsClosedHeader: 'Подтвердить Пометку как Закрытый',
    markedAsClosedSuccess: 'Проект успешно помечен как закрытый',
    confirmCloseProjectTitle: 'Подтвердить Закрытие Проекта',
    confirmCloseProjectDescription: 'Вы уверены, что хотите отметить этот проект как закрытый?',
    confirmReopenProjectTitle: 'Подтвердить Повторное Открытие Проекта',
    confirmReopenProjectDescription: 'Вы уверены, что хотите повторно открыть этот проект?',
    cannotCloseProjectDueOpenPSSRs: 'Невозможно закрыть проект, так как есть открытые PSSR.',
    projectUpdatedSuccessfully: 'Проект успешно обновлен',
    loadNewQaqcItems: 'Загрузить новые элементы QAQC',
    qaqcItemsLoadedSuccessfully: 'Новые элементы QAQC успешно загружены',
    qaqcItemsUpToDate: 'Элементы QAQC уже актуальны',
    qaqcInputWarning: 'Заполните обязательные поля QAQC перед загрузкой новых элементов: {{fields}}.',
    initiateAll: 'Инициировать все ППТБ',
    initiateAllTitle: 'Инициировать все ППТБ',
    initiateAllDescription: 'Вы хотите инициировать все ППТБ этого проекта?',
    initiateAllSuccess: 'Все ППТБ успешно инициированы',
    initiateAllPartialError: 'Некоторые ППТБ не удалось инициировать:',
    projectReopenedSuccessfully: 'Проект успешно переоткрыт',
    restorePssr: 'Восстановить',
    confirmRestoreProject: 'Вы уверены, что хотите восстановить этот проект?',
    confirmRestoreProjectHeader: 'Подтвердить Восстановление',
    restoreSuccess: 'Проект успешно восстановлен',
    deleteDialog: {
      title: 'Подтвердить удаление проекта',
      confirmDeleteWithPssrs: 'Следующее действие может удалить Проект и связанные с ним ППТБ. Вы хотите продолжить?',
      confirmDeleteWithoutPssrs: 'Вы хотите продолжить?',
      deleteProjectAndPssrs: 'Удалить Проект и ППТБ',
      deleteProjectOnly: 'Удалить только Проект',
      deleteSuccess: 'Проект успешно удален',
      deleteError: 'Ошибка при удалении проекта',
    },
    cascadeDialog: {
      cascade: 'каскад',
      title: 'Каскадные Роли',
      description: 'Выберите участников, которых вы хотите применить каскадом ко всем ППТБ этого проекта.',
      teamLeads: 'Руководители Команды',
      teamMembers: 'Члены Команды',
      operationsRepresentative: 'Представитель Операций',
      finalApprover: 'Окончательный Утверждающий',
      apply: 'применить',
      success: 'Роли успешно применены каскадом',
    },
    errors: {
      noPermissionToEditParticipants: 'У вас нет разрешения на редактирование участников этого проекта',
    },
  },
  multiselect: {
    selectedItems: '{0} элементов выбрано',
    placeholder: 'выбрать',
  },
  support: {
    title: 'Обратная связь',
    buSupportInfo: 'Информация о поддержке BU ePSSR',
    serviceNowInstructions: 'Инструкции по созданию заявок ePSSR Service Now',
    instructions: {
      step1:
        'Перейдите к форме <a class="support-link" href="https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981&sysparm_u_appid=1500000886" target="_blank" rel="noopener">Запрос поддержки приложения</a> на Портале ИТ-услуг Chevron',
      step1LinkText: 'Запрос поддержки приложения',
      step2: 'В поле Приложение выберите <b>Mobile PSSR</b>.',
      step3:
        'Чтобы сообщить о проблеме или ошибке, выберите <b>Сообщить о проблеме</b>. Чтобы отправить запрос на улучшение или доступ пользователя, выберите <b>Запрос на обслуживание</b>. Нажмите Далее.',
    },
    reportIssue: {
      title: 'Сообщить о проблеме',
      step1: 'Заполните Описание проблемы, Влияние и Срочность.',
      step2: 'Нажмите Далее, затем Отправить.',
      step3: 'Команда поддержки ePSSR подтвердит получение заявки в течение 24 часов в рабочее время.',
    },
    enhancement: {
      title: 'Запрос на улучшение',
      step1: 'Пожалуйста, выберите <b>Улучшения</b> в разделе Тип запросов.',
      step2: 'Выберите Приоритет (<b>Низкий, Средний, Высокий</b>)',
      step3: 'Заполните Описание запроса',
      step4: 'Выберите Далее и Отправить.',
      step5:
        'Команда поддержки ePSSR рассмотрит запросы на улучшение в рамках процесса планирования PI Surface Digital',
    },
    userAccess: {
      title: 'Запрос доступа пользователя',
      step1: 'Пожалуйста, выберите <b>Запросить доступ</b> в разделе Тип запросов.',
      step2: 'Выберите Тип запроса доступа (<b>Добавить или Удалить</b>)',
      step3: 'Выберите пользователя',
      step4: 'Выберите Приоритет (<b>Низкий, Средний, Высокий</b>)',
      step5: 'Укажите Роль и Доступ, которые нужны пользователю.',
      step6: 'Выберите Далее и Отправить.',
      step7: 'Команда поддержки ePSSR подтвердит получение заявки в течение 24 часов в рабочее время.',
    },
  },
  datepicker: {
    dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    dayNamesShort: ['Вск', 'Пон', 'Втр', 'Срд', 'Чтв', 'Птн', 'Суб'],
    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthNames: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
    monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    today: 'Сегодня',
    clear: 'Очистить',
    dateFormat: 'mm/dd/yy',
    weekHeader: 'Нед',
  },
  errors: {
    unauthorized: {
      title: 'Несанкционированный доступ',
      message: 'У вас нет прав для доступа к этой странице.',
    },
    serverError: {
      title: 'Ошибка сервера',
      message: 'Произошла непредвиденная ошибка. Повторите попытку позже.',
    },
    pageNotFound: {
      title: 'Страница не найдена',
      message: 'Страница, которую вы ищете, не существует.',
    },
    actions: {
      returnHome: 'Вернуться на главную',
    },
  },
  attachments: {
    sections: {
      images: 'Изображения',
      documents: 'Документы',
      links: 'Ссылки',
    },
    actions: {
      download: 'Скачать',
      delete: 'Удалить',
    },
    labels: {
      uploaded: 'Загружено',
    },
  },
  imagePreview: {
    errorMessage: 'Не удалось загрузить изображение',
    errorDetails: 'Проверьте консоль браузера для подробностей',
  },
  functionalReview: {
    audit: {
      createdBy: 'Создано',
      updatedDate: 'Дата обновления',
      updatedBy: 'Обновлено',
    },
  },
  checklistItem: {
    toolbar: {
      bold: 'Жирный',
      italic: 'Курсив',
      underline: 'Подчеркнутый',
      orderedList: 'Нумерованный список',
      unorderedList: 'Маркированный список',
      codeBlock: 'Блок кода',
      blockQuote: 'Цитата',
    },
    alignment: {
      center: 'по центру',
      right: 'по правому краю',
      justify: 'по ширине',
    },
  },
  pssrSections: {
    actions: {
      removeUser: 'Удалить пользователя',
    },
  },
  pssrParticipantsSections: {
    actions: {
      remove: 'Удалить',
    },
  },
  progressBar: {
    label: 'Прогресс:',
  },
  categories: {
    dialogs: {
      addCategory: 'Добавить категорию',
      editCategory: 'Редактировать категорию',
      createSubCategory: 'Создать новую подкатегорию',
      editSubCategory: 'Редактировать подкатегорию',
    },
    placeholders: {
      subcategoryName: 'Название подкатегории',
    },
  },
  categoriesList: {
    title: 'Категории',
    hideInactiveItems: 'Скрыть неактивные элементы',
    subCategoryName: 'Название подкатегории',
    inactive: '(неактивный)',
    noSubcategories: 'Нет подкатегорий',
    selectHeader: 'Выбрать',
    actions: {
      createSubCategory: 'Создать новую подкатегорию',
      restore: 'Восстановить',
      add: 'Добавить',
      addSubCategories: 'Добавить подкатегории',
      remove: 'Убрать',
    },
    deleteDisabledTooltip: 'Эту категорию невозможно удалить, так как она содержит активные подкатегории',
    dialogs: {
      addSubCategoriesHeader: 'Добавить подкатегории',
      deleteCategoryHeader: 'Внимание',
      deleteCategoryMessage: 'Вы уверены, что хотите удалить Категорию: [{{name}}]?',
      deleteSubCategoryHeader: 'Внимание',
      deleteSubCategoryMessage: 'Убрать [{{name}}] из категории [{{category}}]? Сама подкатегория удалена не будет.',
    },
    validation: {
      subCategoryExists: 'Подкатегория с таким названием уже существует',
      categoryExists: 'Категория с таким названием уже существует',
    },
  },
};
export default ru;
